// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Überschreibt den Hauptcontainer */
.cookie-container {
    background-color: rgb(0, 0, 0) !important; /* Wichtigkeit erzwingen */
    color: rgb(161, 161, 161) !important;
    text-align: center !important;
    padding: 10px !important;
    border-top: 1px solid rgb(161, 161, 161) !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 auto !important;
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1000 !important;
    opacity: 0.7 !important;
  }
  
  /* Überschreibt den Button */
  .cookie-button {
    color: rgb(0, 0, 0) !important;
    background-color: rgb(211, 211, 211) !important;
    border: 1px solid rgb(161, 161, 161) !important;
    border-radius: 8px !important;
    padding: 10px 20px !important;
    font-weight: bold !important;
    cursor: pointer !important;
    width: -moz-fit-content !important;
    width: fit-content !important;
    max-width: 300px !important;
    justify-content: center !important;
    align-items: center !important;
    display: flex !important;
  }
  
  /* Mobile Ansicht: Button mittig platzieren */
  @media (max-width: 768px) {
    .cookie-container {
        display: flex !important;
        justify-content: center !important; /* Zentriert den Inhalt horizontal */
        align-items: center !important; /* Zentriert den Inhalt vertikal (falls nötig) */
      }
    
      .cookie-button {
        margin: 0 !important; /* Keine extra Abstände, da Flexbox zentriert */
      }
  }
  
  `, "",{"version":3,"sources":["webpack://./src/pages/components/cookie/cookie.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;IACI,yCAAyC,EAAE,0BAA0B;IACrE,oCAAoC;IACpC,6BAA6B;IAC7B,wBAAwB;IACxB,mDAAmD;IACnD,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA,4BAA4B;EAC5B;IACE,8BAA8B;IAC9B,+CAA+C;IAC/C,+CAA+C;IAC/C,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,0BAA0B;IAC1B,kCAA6B;IAA7B,6BAA6B;IAC7B,2BAA2B;IAC3B,kCAAkC;IAClC,8BAA8B;IAC9B,wBAAwB;EAC1B;;EAEA,6CAA6C;EAC7C;IACE;QACI,wBAAwB;QACxB,kCAAkC,EAAE,oCAAoC;QACxE,8BAA8B,EAAE,gDAAgD;MAClF;;MAEA;QACE,oBAAoB,EAAE,+CAA+C;MACvE;EACJ","sourcesContent":["/* Überschreibt den Hauptcontainer */\r\n.cookie-container {\r\n    background-color: rgb(0, 0, 0) !important; /* Wichtigkeit erzwingen */\r\n    color: rgb(161, 161, 161) !important;\r\n    text-align: center !important;\r\n    padding: 10px !important;\r\n    border-top: 1px solid rgb(161, 161, 161) !important;\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n    margin: 0 auto !important;\r\n    position: fixed !important;\r\n    bottom: 0 !important;\r\n    left: 0 !important;\r\n    right: 0 !important;\r\n    z-index: 1000 !important;\r\n    opacity: 0.7 !important;\r\n  }\r\n  \r\n  /* Überschreibt den Button */\r\n  .cookie-button {\r\n    color: rgb(0, 0, 0) !important;\r\n    background-color: rgb(211, 211, 211) !important;\r\n    border: 1px solid rgb(161, 161, 161) !important;\r\n    border-radius: 8px !important;\r\n    padding: 10px 20px !important;\r\n    font-weight: bold !important;\r\n    cursor: pointer !important;\r\n    width: fit-content !important;\r\n    max-width: 300px !important;\r\n    justify-content: center !important;\r\n    align-items: center !important;\r\n    display: flex !important;\r\n  }\r\n  \r\n  /* Mobile Ansicht: Button mittig platzieren */\r\n  @media (max-width: 768px) {\r\n    .cookie-container {\r\n        display: flex !important;\r\n        justify-content: center !important; /* Zentriert den Inhalt horizontal */\r\n        align-items: center !important; /* Zentriert den Inhalt vertikal (falls nötig) */\r\n      }\r\n    \r\n      .cookie-button {\r\n        margin: 0 !important; /* Keine extra Abstände, da Flexbox zentriert */\r\n      }\r\n  }\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
